var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col flex-1"},[(_vm.title)?_c('div',{staticClass:"flex items-center justify-center bg-blue-400 px-2 py-1 text-white text-center font-medium"},[_c('span',{staticClass:"truncate",attrs:{"role":"title"}},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{staticClass:"divide-y"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }